import { c as h, g as be } from "./_commonjsHelpers-DaMA6jEr.js";
var I, U;
function ie() {
  if (U) return I;
  U = 1;
  function r(e) {
    var n = typeof e;
    return e != null && (n == "object" || n == "function");
  }
  return I = r, I;
}
var R, H;
function de() {
  if (H) return R;
  H = 1;
  var r = typeof h == "object" && h && h.Object === Object && h;
  return R = r, R;
}
var x, X;
function ae() {
  if (X) return x;
  X = 1;
  var r = de(), e = typeof self == "object" && self && self.Object === Object && self, n = r || e || Function("return this")();
  return x = n, x;
}
var E, z;
function me() {
  if (z) return E;
  z = 1;
  var r = ae(), e = function() {
    return r.Date.now();
  };
  return E = e, E;
}
var k, J;
function le() {
  if (J) return k;
  J = 1;
  var r = /\s/;
  function e(n) {
    for (var i = n.length; i-- && r.test(n.charAt(i)); )
      ;
    return i;
  }
  return k = e, k;
}
var G, K;
function ve() {
  if (K) return G;
  K = 1;
  var r = le(), e = /^\s+/;
  function n(i) {
    return i && i.slice(0, r(i) + 1).replace(e, "");
  }
  return G = n, G;
}
var N, Q;
function oe() {
  if (Q) return N;
  Q = 1;
  var r = ae(), e = r.Symbol;
  return N = e, N;
}
var w, V;
function ge() {
  if (V) return w;
  V = 1;
  var r = oe(), e = Object.prototype, n = e.hasOwnProperty, i = e.toString, o = r ? r.toStringTag : void 0;
  function m(u) {
    var f = n.call(u, o), c = u[o];
    try {
      u[o] = void 0;
      var t = !0;
    } catch {
    }
    var s = i.call(u);
    return t && (f ? u[o] = c : delete u[o]), s;
  }
  return w = m, w;
}
var L, Y;
function Te() {
  if (Y) return L;
  Y = 1;
  var r = Object.prototype, e = r.toString;
  function n(i) {
    return e.call(i);
  }
  return L = n, L;
}
var W, Z;
function je() {
  if (Z) return W;
  Z = 1;
  var r = oe(), e = ge(), n = Te(), i = "[object Null]", o = "[object Undefined]", m = r ? r.toStringTag : void 0;
  function u(f) {
    return f == null ? f === void 0 ? o : i : m && m in Object(f) ? e(f) : n(f);
  }
  return W = u, W;
}
var C, ee;
function ye() {
  if (ee) return C;
  ee = 1;
  function r(e) {
    return e != null && typeof e == "object";
  }
  return C = r, C;
}
var P, re;
function Se() {
  if (re) return P;
  re = 1;
  var r = je(), e = ye(), n = "[object Symbol]";
  function i(o) {
    return typeof o == "symbol" || e(o) && r(o) == n;
  }
  return P = i, P;
}
var A, te;
function _e() {
  if (te) return A;
  te = 1;
  var r = ve(), e = ie(), n = Se(), i = NaN, o = /^[-+]0x[0-9a-f]+$/i, m = /^0b[01]+$/i, u = /^0o[0-7]+$/i, f = parseInt;
  function c(t) {
    if (typeof t == "number")
      return t;
    if (n(t))
      return i;
    if (e(t)) {
      var s = typeof t.valueOf == "function" ? t.valueOf() : t;
      t = e(s) ? s + "" : s;
    }
    if (typeof t != "string")
      return t === 0 ? t : +t;
    t = r(t);
    var d = m.test(t);
    return d || u.test(t) ? f(t.slice(2), d ? 2 : 8) : o.test(t) ? i : +t;
  }
  return A = c, A;
}
var D, ne;
function he() {
  if (ne) return D;
  ne = 1;
  var r = ie(), e = me(), n = _e(), i = "Expected a function", o = Math.max, m = Math.min;
  function u(f, c, t) {
    var s, d, S, g, b, v, T = 0, F = !1, j = !1, q = !0;
    if (typeof f != "function")
      throw new TypeError(i);
    c = n(c) || 0, r(t) && (F = !!t.leading, j = "maxWait" in t, S = j ? o(n(t.maxWait) || 0, c) : S, q = "trailing" in t ? !!t.trailing : q);
    function O(a) {
      var l = s, y = d;
      return s = d = void 0, T = a, g = f.apply(y, l), g;
    }
    function ue(a) {
      return T = a, b = setTimeout(_, c), F ? O(a) : g;
    }
    function fe(a) {
      var l = a - v, y = a - T, $ = c - l;
      return j ? m($, S - y) : $;
    }
    function M(a) {
      var l = a - v, y = a - T;
      return v === void 0 || l >= c || l < 0 || j && y >= S;
    }
    function _() {
      var a = e();
      if (M(a))
        return B(a);
      b = setTimeout(_, fe(a));
    }
    function B(a) {
      return b = void 0, q && s ? O(a) : (s = d = void 0, g);
    }
    function ce() {
      b !== void 0 && clearTimeout(b), T = 0, s = v = d = b = void 0;
    }
    function se() {
      return b === void 0 ? g : B(e());
    }
    function p() {
      var a = e(), l = M(a);
      if (s = arguments, d = this, v = a, l) {
        if (b === void 0)
          return ue(v);
        if (j)
          return clearTimeout(b), b = setTimeout(_, c), O(v);
      }
      return b === void 0 && (b = setTimeout(_, c)), g;
    }
    return p.cancel = ce, p.flush = se, p;
  }
  return D = u, D;
}
var qe = he();
const pe = /* @__PURE__ */ be(qe);
export {
  pe as d
};
